import Label from 'components/ui/Label'
import LeadSettingsData from 'interfaces/LeadSettings/LeadSettings'
import React from 'react'

interface Props {
    leadSetting: LeadSettingsData | null
}

const LimitReachedLabel: React.FC<Props> = ({ leadSetting }) => {
    const limitTypes = ['day_limit_reached', 'week_limit_reached', 'month_limit_reached'] as const
    const limitsReached = limitTypes
        .map((limitType) => {
            if (!leadSetting) {
                return null
            }
            if (leadSetting[limitType]) {
                return <Label key={limitType} bgColor="#FFD5B3" color="#10185a" text={limitType} />
            }
            return null
        })
        .filter(Boolean)

    return <>{limitsReached}</>
}

export default LimitReachedLabel
